
import React from "react";
import Navbar from "@/components/Navbar";
import SubmitForm from "@/components/SubmitForm";
import { Leaf } from "lucide-react";

const Submit = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="container py-12">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <Leaf className="h-12 w-12 text-eco-500 mx-auto mb-4" />
            <h1 className="text-3xl font-bold mb-4">Add a Sustainable Business</h1>
            <p className="text-muted-foreground">
              Help our community discover eco-friendly businesses by adding new listings to our database. Please provide accurate and detailed information.
            </p>
          </div>
          
          <div className="border rounded-lg p-6 bg-white shadow-sm">
            <SubmitForm />
          </div>
          
          <div className="mt-8 p-4 bg-eco-50 rounded-lg border border-eco-100">
            <h3 className="font-medium mb-2">What happens next?</h3>
            <p className="text-sm text-muted-foreground">
              After submission, our team will review your listing for accuracy and relevance. Once approved, it will appear in our database, typically within 1-2 business days. Thank you for contributing to our sustainable community!
            </p>
          </div>
        </div>
      </div>
      
      <footer className="bg-gray-100 py-6 mt-12">
        <div className="container">
          <div className="text-center text-muted-foreground text-sm">
            <p>&copy; {new Date().getFullYear()} Ourcelium. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Submit;
